
import { Nav, NavDropdown, Navbar } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { AppState } from "../../store/configureStore";
import { logoutRequested } from "../../store/users/auth";
import { roles } from "../../util/config/roles";

import Avatar from "../Avatar/Avatar";
import CompanyLogo from "../CompanyLogo/CompanyLogo";
import LocaleSelect from "../Locale/LocaleSelect";
import ContractSelect from "./ContractSelect";

import "./navMenu.css";
import Hamburger from "../Sidebar/Hamburger";


export const NavMenu = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation("common");


    const role = roles();
  
    const { sidebarIsOpen } = useSelector((state: AppState) => state.entities.sidebar);

    const logout = (e: React.MouseEvent) => {
        e.preventDefault();
        dispatch({ type: logoutRequested.type });
    };

    return (
        <Navbar
            className={`navbar navbar-expand ${!sidebarIsOpen ? " sidebar_closed":''}`}
        >
            <CompanyLogo />
            <Hamburger />

        {/*    {!role.isSuperAdmin && <ContractSelect />}*/}
            <Nav className="user-menu" navbar>
                <NavDropdown
                    className="user-dropdown navDropdown me-2"
                    drop="down-centered"
                    title={
                        <Avatar />
                    }
                >
                    {/* <NavDropdown.Item className="nowrap" href="/Password">
                        <div>{t("navmenu.changePassword")}</div>
                    </NavDropdown.Item>
                    <NavDropdown.Divider className="m-1" /> */}
                    <NavDropdown.Item className="nowrap" href="/" onClick={logout}>
                        <div>{t("navmenu.logout")}</div>
                    </NavDropdown.Item>
                </NavDropdown>

                <LocaleSelect />
            </Nav>
        </Navbar>
    );
};

export default NavMenu;
